export default __webpack_public_path__ + "static/media/custom-domain.40b46c11.svg";